<div class="w-full h-full bg-body-background relative overflow-hidden flex flex-col">

  @if (activeInsights().length > 0) {
  <div class="p-4 border-b border-primary-border bg-component-header shrink-0 flex items-center justify-between">
    <button (click)="clearInsight()"
            class="text-secondary-text hover:text-primary transition-colors flex items-center gap-2 font-medium">
      <i class="fas fa-arrow-left"></i> Back to Timeline
    </button>
  </div>
  <div class="flex-1 overflow-y-auto custom-scrollbar flex flex-col gap-6 p-4 bg-body-background">
    @for (insight of activeInsights(); track insight.projectModelName) {
    <rapider-data-insight [event]="insight"></rapider-data-insight>
    }
  </div>
  } @else {
  <rapider-data-insight-timeline class="flex-1"></rapider-data-insight-timeline>
  }

</div>